// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"0591aba9","161":"cd2a6455","239":"e7a2ff17","241":"8db97bd6","355":"9c2c1313","396":"46c444e3","455":"5bf521cd","673":"7b190eb5","715":"34b33152","722":"c4662f89","857":"44e4468d","882":"13787e7e","889":"526b6631","977":"a723575a"}[chunkId] + ".chunk.js";
};